import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import { ShapeCategory } from '@/types/shapeCategories';

export default class QuarterCircleConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'radius',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle ): Record<string, Length> {

		// Because a quarter circle only uses half of a plate a circle uses we should double the maximum diameter.
		return {
			radius: maximum_rectangle.get_shortest_side()
		};
	}

	get_labels(): Record<string, string> {
		const { radius } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			radius
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			radius: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'circular';
	}
}
